import { useRef, useState } from 'react';
import {
  IonBreadcrumb,
  IonBreadcrumbs,
  IonContent,
  IonFab,
  IonFabButton,
  IonIcon,
  IonPage,
  IonRefresher,
  IonRefresherContent,
} from '@ionic/react';
import Nav from './nav/index';
import Footer from './footer/index';
import classes from './Layout.module.scss';
import { chevronUp } from 'ionicons/icons';
import SEOHeader, { SEOHeaderProps } from '../../SEO';
import WhatsappFAB from '../../WhatsappFAB';

interface LayoutProps {
  children: React.ReactNode;
  enableScrollToToP?: boolean;
  enableRefresh?: boolean;
  handleRefresh?: (event: CustomEvent) => void;
  seoData?: SEOHeaderProps;
  whatsappContact?: string;
}

const Layout = ({
  children,
  enableScrollToToP = false,
  enableRefresh = false,
  handleRefresh,
  seoData,
  whatsappContact
}: LayoutProps) => {
  const locations: any[] = [];
  const [showBackToTopButton, setShowBackToTopButton] = useState(false);
  const contentRef = useRef<HTMLIonContentElement | null>(null);

  const handleScroll = async (event: CustomEvent) => {
    const scrollTop = event.detail.scrollTop;
    // Show button after scrolling 200px
    setShowBackToTopButton(scrollTop > 200);
  };

  const scrollToTop = () => {
    contentRef.current?.scrollToTop(500);
  };

  return (
    <IonPage id="main-content">
      <SEOHeader {...seoData} />
      <IonContent
        ref={contentRef}
        onIonScroll={handleScroll}
        scrollEvents={true}
        className={classes.AppCarrier}
      >
        {/* Pull to Refresh */}
        {enableRefresh && handleRefresh && (
          <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
            <IonRefresherContent></IonRefresherContent>
          </IonRefresher>
        )}
        <div
          className={
            'fixed h-[10dvh] w-full border-b border-primary bg-white z-[99999]'
          }
          id={'nav'}
        >
          <Nav />
        </div>
        <div className="w-full h-auto min-h-[65dvh] flex-1 mt-[10dvh]">
          <div className={classes.breadCrumbs + ' hidden'}>
            <IonBreadcrumbs>
              {locations.map((item: any, index: any) => {
                return (
                  <IonBreadcrumb color="primary" href={`/${item}`} key={index}>
                    {item}
                  </IonBreadcrumb>
                );
              })}
            </IonBreadcrumbs>
          </div>
          <div className={classes.children}>{children}</div>
        </div>
        <div className="w-full h-auto">
          <Footer />
        </div>

      {whatsappContact && (
        <WhatsappFAB number={whatsappContact} className={enableScrollToToP && showBackToTopButton ? '!bottom-[4.5rem]' : ''} />
      )}
        {/* Scroll to top */}
        {enableScrollToToP && showBackToTopButton && (
          <IonFab slot="fixed" className="!right-5">
            <IonFabButton size="small" onClick={scrollToTop}>
              <IonIcon icon={chevronUp} />
            </IonFabButton>
          </IonFab>
        )}
      </IonContent>
    </IonPage>
  );
};

export default Layout;
